// LIBRARIES
import styled from "styled-components";

// MISC
import { BOXSHADOW, COLORS, FONTS, WIDTH } from "constants/styleVariables";

export const ReportStatisticContainer = styled.div`
  display: flex;
  flex-direction: column;
  // margin-bottom: 20px;
`;

export const ContainerTitle = styled.div`
  font-family: ${FONTS.montserrat};
  font-size: 20px;
  font-weight: bold;
`;

export const ReportStatisticWrapper = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 24px;
  // box-shadow: ${BOXSHADOW.containerBoxShadow};
  display: flex;
  flex-direction: column;
  background-color: #F5F5F5;
  margin-top: 20px;
  padding: 20px;

  @media (${WIDTH.mediumWidth}) {
    width: 620px;
  }
  @media (${WIDTH.tabletWidth}) {
    width: 600px;
  }
`;

export const ReportStatisticContent = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
`;

export const ReportStatisticElement = styled.div`
  &:first-child {
    border-right: 2px solid ${COLORS.backgroundColor};
    padding: 10px 0 30px 0;
  }
  &:nth-child(2) {
    padding: 10px 0 30px 20px;
  }
  &:nth-child(3) {
    border-top: 2px solid ${COLORS.backgroundColor};
    border-right: 2px solid ${COLORS.backgroundColor};
    padding: 30px 0 10px 0;
  }
  &:nth-child(4) {
    border-top: 2px solid ${COLORS.backgroundColor};
    padding: 30px 0 10px 20px;
  }
`;
